import axios from 'axios';
import qs from 'qs';
import isObject from 'lodash-es/isObject';

export default defineNuxtPlugin({
    name: 'axios',
    dependsOn: [],
    async setup(nuxtApp)
    {
        axios.defaults.baseURL = getApiUrl();
        axios.defaults.withCredentials = true;
        axios.defaults.headers.common = {
            ...axios.defaults.headers.common,
            ...{
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0'
            }
        };
        axios.interceptors.request.use((config) =>
        {
            config.headers['Accept-Language'] = useNuxtApp().$i18n?.locale() || '';
            config.paramsSerializer = {
                serialize: (params) =>
                {
                    return qs.stringify(datesToString(params), {
                        arrayFormat: 'indices',
                        encode: false
                    });
                }
            };

            return config;
        });
        axios.interceptors.response.use((response) =>
        {
            if (response && response.headers && response.headers['content-type']?.includes('json') && response.config?.responseType !== 'blob' && isObject(response.data))
                response.data = convertDates(response.data);

            return response;
        });

        return {
            provide: {
                axios: axios,
                http: axios
            }
        };
    }
});

declare module '@vue/runtime-core'
{
    interface ComponentCustomProperties
    {
        $axios: typeof axios;
        $http: typeof axios;
    }
}
